import { edmCampaign } from '@bingads-webui/edm-campaign';

export const getAutoGoalRecommendations = (cid, aid) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Goals['Default.GetGoalRecommendation']
  .get().toPromise();
